module.exports = __webpack_public_path__ + "img/13-en_home_linefd.3849ee2f.png";